export const RADIO_BUTTON_ITEM_SIZE_LIST = ['md', 'lg'];
export const ICON_POSITION_LIST = ['left', 'right'];
